module.exports = __webpack_public_path__ + "images/emoji/closed_umbrella.92cd53aa3dcf32a44806.png";